<template>
    <section>
        mapa
    </section>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>